import { DatePickerProps } from '@koda/koda-components/molecules/DatePicker';
import dayjs from 'dayjs';

export const Past5Years: DatePickerProps['interval'] = {
  from: dayjs().subtract(5, 'year').startOf('year').toDate(),
  to: dayjs().subtract(1, 'day').toDate(),
};

export const Past5YearsFuture2Years: DatePickerProps['interval'] = {
  from: dayjs().subtract(5, 'year').startOf('year').toDate(),
  to: dayjs().add(2, 'year').endOf('day').toDate(),
};

export const CurrentAndPreviousYear: DatePickerProps['interval'] = {
  from: dayjs().subtract(1, 'year').startOf('year').toDate(),
  to: dayjs().subtract(1, 'day').endOf('day').toDate(),
};
